import { RootState } from '@/store/state'

export default {
    setNotifications(state:RootState, payload:{count:number, suggest_posts: Array<{ board_key:string, post_key:string }>}) {
        state.notificationsState.suggest_posts = payload.suggest_posts
        state.notificationsState.count = payload.count
    },
}
